import React, {Component} from "react";
import {Translate, translate} from "react-i18nify";

import * as rcc from "../../../constants/rcc";
import * as config from "../../../constants/config";
import * as settings from "../../../constants/settings";
import * as validationHelper from "../../../helpers/validationHelper";
import * as modelHelper from "../../../helpers/modelHelper";

import imgPurge from "../../../resources/img/svgicons/purge2.svg";

import NumericKeyboardInput from "../../global/NumericKeyboardInput";
import CancelButton from "../generic/CancelButton";
import Button from "../generic/Button";
import Modal from "../generic/Modal";

export default class PurgeModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedChannels: [],
            volume: rcc.RCC_DEFAULT_PURGE_VOLUME
        };
    }

    setPurgeVolumeState = (value) => {
        if (validationHelper.isDecimalValueValid(value)) {
            this.setState({
                volume: validationHelper.formatDecimal(value)
            });
        }
    };

    handleCloseModalClick = () => {
        this.props.closeModal();
    };

    handleToggleSelectChannelClick = (event) => {
        let channel = this.getChannelFromList(Number(event.target.dataset.id));

        if (channel !== null) {
            if (this.isChannelSelected(channel)) {
                this.setState({
                    selectedChannels: this.state.selectedChannels.filter((selected) => selected.id !== channel.id)
                });
            } else {
                this.setState({
                    selectedChannels: [...this.state.selectedChannels, channel]
                });
            }
        }
    };

    handleVolumeFocus = (event) => {
        event.target.select();
    };

    handleVolumeChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({
                volume: validationHelper.formatDecimal(event.target.value)
            });
        }
    };

    handleVolumeBlur = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({
                volume: validationHelper.formatDecimal(event.target.value)
            });
        }
    };

    handleSelectAllClick = () => {
        this.setState({
            selectedChannels: this.getEnabledChannels()
        });
    };

    handleClearClick = () => {
        this.setState({
            selectedChannels: []
        });
    };

    handleStartPurgingClick = () => {
        let channelIndexes = this.state.selectedChannels.map((channel) => channel.id);

        if (channelIndexes.length > 0 && Number(this.state.volume) > 0) {
            let index,
                channels = [];
            for (index of channelIndexes) {
                channels.push({volume: Number(this.state.volume), index: Number(index)});
            }

            this.props.closeModal();
            this.props.purgeChannels(channels);
        }
    };

    getEnabledChannels = () => {
        return this.props.channelList.filter((channel) => channel.enabled);
    };

    getChannelFromList = (channelId) => {
        let channel;
        for (channel of this.props.channelList) {
            if (channel.id === channelId) {
                return channel;
            }
        }

        return null;
    };

    isChannelSelected = (channel) => {
        if (this.state.selectedChannels.length === 0) {
            return false;
        }

        let selectedChannel;
        for (selectedChannel of this.state.selectedChannels) {
            if (selectedChannel.id === channel.id) {
                return true;
            }
        }

        return false;
    };

    getColorantByChannel = (channel) => {
        let colorant;
        for (colorant of this.props.colorantList) {
            if (channel.colorant.name === colorant.name) {
                return colorant;
            }
        }

        return null;
    };

    getChannelBoxClass = (channel) => {
        if (this.isChannelSelected(channel)) {
            return "active";
        }

        return "";
    };

    getChannelBox = (channel) => {
        let colorant = channel.colorant;
        if (colorant !== null && colorant.rgb === null) {
            colorant = this.getColorantByChannel(channel);
        }

        let colorantRgb = colorant === null || colorant.rgb === null ? config.DEFAULT_RGB : colorant.rgb;
        let colorantName = colorant === null || colorant.name === null ? "" : colorant.name;

        if (!channel.enabled) {
            return (
                <div key={channel.id} className="general-colorant-select-box disabled">
                    <div className="general-colorant-select-box-id" data-id={channel.id}>
                        {channel.id}
                    </div>
                    <div className="general-colorant-select-box-color" style={{backgroundColor: colorantRgb}} />
                    <div className="general-colorant-select-box-name">{colorantName}</div>
                </div>
            );
        }

        return (
            <div
                key={channel.id}
                className={"general-colorant-select-box " + this.getChannelBoxClass(channel)}
                data-id={channel.id}
                onClick={this.handleToggleSelectChannelClick}
            >
                <div className="general-colorant-select-box-id" data-id={channel.id}>
                    {channel.id}
                </div>
                <div
                    className="general-colorant-select-box-color"
                    style={{backgroundColor: colorantRgb}}
                    data-id={channel.id}
                />
                <div className="general-colorant-select-box-name" data-id={channel.id}>
                    {colorantName}
                </div>
            </div>
        );
    };

    getChannelList = () => {
        return (
            <div className="general-wrapper-body general-colorant-select-box-wrapper slim-scroll">
                {this.props.channelList.map(this.getChannelBox)}
            </div>
        );
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-12 margin-bottom-10 flex flex-end font-size-2rem flex-align-center-vertical">
                    <Translate value="purgeModal.purgeVolume" />
                    &nbsp;
                    <NumericKeyboardInput
                        type="text"
                        className="width-60px text-center general-input primary-input"
                        value={this.state.volume}
                        onFocus={this.handleVolumeFocus}
                        onChange={this.handleVolumeChange}
                        onBlur={this.handleVolumeBlur}
                        extended={true}
                        setInputState={this.setPurgeVolumeState}
                    />
                    <span style={{marginLeft: "5px"}}>{settings.UNIT_ML}</span>
                </div>
                <div className="general-wrapper flex-child">
                    <div className="general-wrapper-header flex margin-bottom-10 flex-align-center-vertical">
                        {translate("general.selectChannels")}
                        <Button
                            className="margin-left-auto"
                            onClick={
                                this.state.selectedChannels.length < this.getEnabledChannels().length
                                    ? this.handleSelectAllClick
                                    : this.handleClearClick
                            }
                            label={
                                this.state.selectedChannels.length < this.getEnabledChannels().length
                                    ? translate("general.selectAll")
                                    : translate("general.clear")
                            }
                        />
                    </div>
                    {this.getChannelList()}
                </div>
            </React.Fragment>,
            "flex-column"
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <Button
                    onClick={this.handleStartPurgingClick}
                    svgBefore={imgPurge}
                    label={<Translate value="general.purge" />}
                    disabled={this.state.selectedChannels.length === 0 || Number(this.state.volume) === 0}
                />
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>,
            "flex-gap-10px"
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="serviceActionsSettings.purgeChannels" />)}
                content={this.getContent()}
                footer={this.getFooter()}
            />
        );
    }
}
